import React, { Suspense, useEffect, useState } from 'react';
import { createBrowserHistory } from 'history';
import RootWrapper from './wrappers/RootWrapper';
import { Router } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import configs from 'config';
import { ConfigProvider } from 'antd';
import 'moment/locale/ja';
import en_US from 'antd/lib/locale/en_US';
import ja_JP from 'antd/lib/locale/ja_JP';
import LoadingScreen from 'components/LoadingScreen';
import IsMobileProvider from 'components/WrapperContext/IsMobileProvider';
import IsTourOpenProvider from 'components/WrapperContext/IsTourOpenProvider';
import { setResourceI18n } from 'helper/i18n';
import { useTranslation } from 'react-i18next';
import { LANGUAGE } from 'common';
import ScrollToTop from 'components/ScrollToTop';
export const history = createBrowserHistory();
export const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 24 * 3600 * 1000, // cache for 1 day
      retry: false,
    },
  },
});
function App() {
  const [loadingLang, setLoadingLang] = useState(true);
  const { i18n } = useTranslation();
  useEffect(() => {
    const getLanguage = async () => {
      await setResourceI18n();
      setLoadingLang(false);
    };
    getLanguage();
  }, []);

  if (loadingLang) return <LoadingScreen />;
  return (
    <QueryClientProvider client={client}>
      <React.StrictMode>
        <ConfigProvider locale={i18n?.language === LANGUAGE.JA ? ja_JP : en_US}>
          <Router history={history}>
            <Suspense fallback={null}>
              <IsMobileProvider>
                <IsTourOpenProvider>
                  <ScrollToTop />
                  <RootWrapper />
                </IsTourOpenProvider>
              </IsMobileProvider>
              {configs.APP_ENV !== 'prod' && <ReactQueryDevtools initialIsOpen={false} />}
            </Suspense>
          </Router>
        </ConfigProvider>
      </React.StrictMode>
    </QueryClientProvider>
  );
}

export default App;
